var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 10.8889C20.25 13.0928 18.9651 15.7033 17.1927 17.8014C16.3165 18.8387 15.3496 19.7157 14.4183 20.3274C13.4717 20.9492 12.6339 21.25 12 21.25V22.75C13.0536 22.75 14.1845 22.2756 15.2418 21.5811C16.3145 20.8766 17.3867 19.8962 18.3386 18.7694C20.2224 16.5393 21.75 13.5941 21.75 10.8889H20.25ZM12 21.25C11.3661 21.25 10.5283 20.9492 9.58168 20.3274C8.65039 19.7157 7.68353 18.8387 6.80731 17.8014C5.03493 15.7033 3.75 13.0928 3.75 10.8889H2.25C2.25 13.5941 3.77757 16.5393 5.66144 18.7694C6.61334 19.8962 7.68554 20.8766 8.75817 21.5811C9.81548 22.2756 10.9464 22.75 12 22.75V21.25ZM3.75 10.8889C3.75 6.40266 7.43484 2.75 12 2.75V1.25C6.62403 1.25 2.25 5.55672 2.25 10.8889H3.75ZM12 2.75C16.5652 2.75 20.25 6.40266 20.25 10.8889H21.75C21.75 5.55672 17.376 1.25 12 1.25V2.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.303e3c8340d7c0a3a1ed6bae20ee88eb.svg";
export { ForwardRef as ReactComponent };